import { useContext, useState, useEffect } from 'react';
import { Clear } from '@mui/icons-material';
import { updateLabelHistoryRecord } from '../../../services/sql/sqlHelpers';
import { appContext } from '../../../AppContext';
import { trimString } from '../../../utils/converter';
import { API } from '../../../config/api';
import axios from 'axios';

interface EditFileLabelProps {
  historyItem: any;
  indexOfHistoryItem: number;
  getHistory: () => void;
  data: any[];
}

const EditFileLabel: React.FC<EditFileLabelProps> = ({
  historyItem,
  indexOfHistoryItem,
  getHistory,
  data,
}) => {
  const { validateState } = useContext(appContext);
  const [isEditing, setIsEditing] = useState(false);
  const [labelInputValue, setLabelInputValue] = useState(historyItem.FILE_LABEL || '');

  useEffect(() => {
    if (isEditing) {
      // console.log('historyItem', historyItem);

      setLabelInputValue(historyItem.FILE_LABEL || '');
    }
  }, [isEditing, historyItem.FILE_LABEL]);

  const handleEditLabel = () => setIsEditing(true);

  const handleSaveLabel = async () => {
    if (!isEditing) return;

    const historyId = data[indexOfHistoryItem].ID;

    await axios.patch(
      API.HISTORY.patch.fileLabel(historyId),
      {
        FILE_LABEL: labelInputValue.trim(),
      },
      { withCredentials: true },
    );

    getHistory();
    setIsEditing(false);
  };

  return (
    <div className="flex flex-row gap-1 items-center">
      {isEditing ? (
        <>
          <input
            className="h-[26px] w-[100px] text-white bg-transparent border-b border-slate-grey focus:outline-none"
            value={labelInputValue}
            name="label"
            onChange={(e) => setLabelInputValue(e.target.value)}
            onBlur={handleSaveLabel}
            onKeyDown={(e) => e.key === 'Enter' && handleSaveLabel()}
            autoFocus
          />
          <button
            onMouseDown={(e) => {
              e.preventDefault();
              setLabelInputValue('');
              setIsEditing(false);
            }}
            className="hover:text-minima-orange-light transition-all duration-300 ease-in-out"
          >
            <Clear fontSize="small" />
          </button>
        </>
      ) : (
        <button
          onClick={handleEditLabel}
          disabled={validateState}
          style={{ textUnderlineOffset: '4px' }}
          className="inline-flex items-center justify-center text-minima-orange-2023 underline hover:text-minima-orange-light transition-all duration-300 ease-in-out"
        >
          {historyItem.FILE_LABEL ? trimString(historyItem.FILE_LABEL) : 'Add Label'}
        </button>
      )}
    </div>
  );
};

export default EditFileLabel;
